<template>
    <div>
        <buttonlist @help="help" @add="add" @del="batchdel" @reflash="reflash" @exps="exps" @save="save" ref="SetBtn"></buttonlist>
        <div>
            <el-button :disabled="!btn.settrue" @click.native.prevent="setStatus(1)" type="primary" size="mini">{{
                $t('getapi[147]')}}
            </el-button>
            <el-button :disabled="!btn.setfalse" @click.native.prevent="setStatus(0)" type="primary" size="mini">{{
                $t('getapi[215]')}}
            </el-button>
        </div>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="issue_dept_code" :label="$t('getapi[6043]')"
                             width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="issue_dept_name" :label="$t('getapi[6044]')"
                             width="200"></el-table-column>
            <el-table-column prop="status_name" :label="$t('getapi[552]')" width="100">
                <template scope="scope">
                    <span>{{ scope.row.status_name | lanchange}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="issue_type" :label="$t('getapi[2285]')" width="100">
                <template scope="scope">
                    <span>{{ exp(scope.row.issue_type) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="production_flag" :label="$t('getapi[13355]')" width="100">
                <template scope="scope">
                    <el-checkbox size="mini" v-model="scope.row.production_flag" :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column :label="$t('getapi[6048]')" width="100">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text"
                               size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[1146]')"
                            :cancelButtonText="$t('getapi[2054]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[6049]')"
                            @onConfirm="del(scope.row)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-dialogDrag :title="$t('getapi[6042]')" :visible.sync="isVisible" width="35%">
    <!--        <el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="120px"
                             label-position="left" size="small">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[6043]')">
                                    <el-input v-model="dataDetail.issue_dept_code"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[6044]')">
                                    <el-input v-model="dataDetail.issue_dept_name"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[552]')">
                                    <el-select v-model="dataDetail.status" :disabled="true">
                                        <el-option :label="$t('getapi[231]')" :value=0></el-option>
                                        <el-option :label="$t('getapi[203]')" :value=1></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$t('getapi[2285]')">
                                    <el-select filterable v-model="dataDetail.issue_type" size="mini">
                                        <el-option :key="0" :label="$t('getapi[6045]')" :value="0"></el-option>
                                        <el-option :key="1" :label="$t('getapi[6046]')" :value="1"></el-option>
                                        <el-option :key="2" :label="$t('getapi[6047]')" :value="2"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>-->
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
            <table>
                <tr>
                    <td>{{$t('getapi[6043]')}}</td>
                    <td><el-input v-model="dataDetail.issue_dept_code" type="text" size="mini"></el-input></td>
                    <td>{{$t('getapi[6044]')}}</td>
                    <td><el-input v-model="dataDetail.issue_dept_name" type="text" size="mini"></el-input></td>
                </tr>
                <tr>
                    <td>{{$t('getapi[552]')}}</td>
                    <td>
                        <el-select v-model="dataDetail.status" :disabled="true">
                            <el-option :label="$t('getapi[231]')" :value=0></el-option>
                            <el-option :label="$t('getapi[203]')" :value=1></el-option>
                        </el-select>
                    </td>
                    <td>{{$t('getapi[2285]')}}</td>
                    <td>
                        <el-select filterable v-model="dataDetail.issue_type" size="mini">
                            <el-option :key="0" :label="$t('getapi[6045]')" :value="0"></el-option>
                            <el-option :key="1" :label="$t('getapi[6046]')" :value="1"></el-option>
                            <el-option :key="2" :label="$t('getapi[6047]')" :value="2"></el-option>
                            <el-option :key="3" :label="$t('getapi[12958]')" :value="3"></el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td>{{$t('getapi[13355]')}}</td>
                    <td>
                        <el-checkbox size="mini" v-model="dataDetail.production_flag" :true-label=1 :false-label=0></el-checkbox>
                    </td>
                </tr>
            </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="small" type="primary" @click="save">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'ssyIssuedeptinfo',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 50, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {},
                selectIDData: [],
                btn: {
                    del: false,
                    edit: false,
                    settrue: false,
                    setfalse: false,
                },
                selectData: [],
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6042]"),this.$t("getapi[12]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                //只读权
                if (that.$limits.ReadOnlyRights('plv2', 199, 1)) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                //操作权
                if (that.$limits.authority('plv2', 199, 1) == 2) {
                    if (that.$limits.authority('plv3', 199, 1) == 0) {
                        //查询级
                        that.btn.edit = false;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 199, 1) == 1) {
                        //编辑级
                        that.btn.edit = true;
                        that.btn.del = false;
                        that.$refs.SetBtn.SetButtonEnable('search,create,save,refresh,export');
                    }
                    if (that.$limits.authority('plv3', 199, 1) == 2) {
                        //删除级
                        that.btn.edit = true;
                        that.btn.del = true;
                        that.$refs.SetBtn.SetButtonEnable('search,create,save,del,refresh,export');
                    }
                }
            },
            btnauthority() {
                let that = this
                console.log(that.selectData)
                that.btn.settrue = false
                that.btn.setfalse = false
                if (that.selectData.length > 0) {
                    that.btn.settrue = that.selectData.every(val => {
                        return val.status == 0
                    });
                    that.btn.setfalse = that.selectData.every(val => {
                        return val.status == 1
                    });
                }
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let data = {};
                that.$http.urlpost('/Sys/Currency/GetSsyIssueDeptList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent.Table;
                        that.loading = false;
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 获取详情
            editInfo(row) {
                let that = this;
                that.isVisible = true;
                let parm = {
                    Code: row.issue_dept_code
                };
                that.$http.urlpost('/Sys/Currency/GetSsyIssueDeptInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                    }
                });
            },
            // 解析
            exp(val) {
                if (val == 0) {
                    return this.$t('getapi[6045]');
                } else if (val == 1) {
                    return this.$t('getapi[6046]');
                } else if (val == 2) {
                    return this.$t('getapi[6047]');
                } else {
                    return '';
                }
            },
            // 导出
            exps() {
                let that = this;
                let parm = {
                    LangType:that.$processdata.getLang(),
                    fromname: that.$t('getapi[4469]')
                };
                that.$http.urlpost('/Sys/Currency/SsyIssueDeptExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            save() {
                let that = this;
                let arr = [];
                arr = [...arr, that.dataDetail];
                let parm = arr;
                that.$http.urlpost('/Sys/Currency/SaveSsyIssueDept', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.isVisible = false;
                        that.getView();
                    }
                });
            },
            add() {
                let that = this;
                that.isVisible = true;
                that.dataDetail = {
                    old_issue_dept_code: '',
                    old_issue_dept_name: '',
                    issue_dept_code: '',
                    issue_dept_name: '',
                    workcenter_code: '',
                    issue_type: 0
                };
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = [];
                that.selectData = []
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData.push(val[i].issue_dept_code);
                    that.selectData.push(val[i])
                }
                that.btnauthority()
            },
            del(row) {
                let that = this;
                let parm = {
                    ids: row.issue_dept_code,
                    exclusively_id: 0
                };
                that.$http.urlpost('/Sys/Currency/DelSysIssueDeptByID', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(Common.SuccessMsg);
                        that.getView();
                    }
                });
            },
            batchdel() {
                let that = this;
                if (that.selectIDData.length == 0) {
                    that.$message.warning(this.$t('getapi[1158]'));
                    return false
                }
                that.$confirm(this.$t('getapi[6049]'), this.$t('getapi[194]'), {
                    confirmButtonText: this.$t('getapi[1146]'),
                    cancelButtonText: this.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = '';
                        for (let i = 0; i < that.selectIDData.length; i++) {
                            ids = ids + that.selectIDData[i] + ',';
                        }
                        ids = ids.substr(0, ids.length - 1);
                        let parm = {
                            ids: ids,
                            exclusively_id: 0
                        };
                        that.$http.urlpost('/Sys/Currency/DelSysIssueDeptByID', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(Common.SuccessMsg);
                                that.getView();
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            setStatus(val) {
                let that = this
                let arr = []
                for (let i = 0; i < that.selectData.length; i++) {
                    arr = [...arr, {
                        issue_dept_code: that.selectData[i].issue_dept_code
                    }]
                }
                let parm = {
                    list: arr,
                    status: val,
                }
                that.$http.urlpost('/Sys/Currency/UpdateIssueDeptStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(res.Msg);
                        that.getView();
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
